<template>
    <component
        :is="props.is"
        :class="$style.seo_only"
        :aria-hidden="props.ariaHidden"
    >
        <slot />
    </component>
</template>
<script lang="ts" setup>
interface OnlySeoProps {
    ariaHidden?: boolean
    is?: keyof HTMLElementTagNameMap
}

const props = withDefaults(defineProps<OnlySeoProps>(), {
    is: 'div',
})
</script>
<style module>
.seo_only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}
</style>
